import useApiWorker from 'hooks/useApiWorker';
import { Rule, RuleIdentifier } from '../types/rule';

const defaultErrorResponse: ApiResponse<Rule> = {
  success: false,
  message: 'An error occurred',
};

export async function ListRules(): Promise<ApiListResponse<RuleIdentifier>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .get<Array<RuleIdentifier>>(`/rules`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}

export async function GetRule(ruleName: string): Promise<ApiResponse<Rule>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .get<Rule>(`/rules/${ruleName}`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return { success: false, message: error.response.data.message };
    });
}

export async function AddRule(rule: Rule): Promise<ApiResponse<Rule>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .post<Rule>(`/rules`, rule)
    .then(() => {
      return { success: true, rule };
    })
    .catch((error) => {
      return {
        rule,
        errors: error.response.data,
        ...defaultErrorResponse,
      };
    });
}

export async function UpdateRule(ruleName: string, rule: Rule): Promise<ApiResponse<Rule>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .put<Rule>(`/rules/${ruleName}`, rule)
    .then(() => {
      return { success: true, rule };
    })
    .catch((error) => {
      return {
        rule,
        errors: error.response.data,
        ...defaultErrorResponse,
      };
    });
}

export async function DeleteRule(rule: Rule): Promise<ApiResponse<Rule>> {
  const { Name } = rule;
  const apiWorker = useApiWorker();

  return apiWorker
    .delete(`/rules/${Name}`)
    .then(() => {
      return { success: true, rule };
    })
    .catch((error) => {
      return { success: false, message: error.response.data };
    });
}
